import { AnimalInfo } from "../AnimalDataCalls/GQLCalls/getAnimalCall";
import { TerminalInfo } from "../LocationFeedingCalls/GQLCalls/getTerminalsCall";
import { Location } from "../..";

export interface StationInfo { // equals "location" in ui
  station_id: number;
  name: string;
  terminals: TerminalInfo[];
  visual: string;
}

export interface EsfSectionsInfo {
  system_id: number;
  section_id: number;
  name: string;
  section_locations: EsfLocation
}

export interface EsfLocation extends Location { // equals "section" in ui
  stations: StationInfo[];
}

export const TestData: EsfSectionsInfo[] = [{
  system_id: 4,
  section_id: 1,
  name: "",
  section_locations: {
    name: "first section",
    location_id: 1,
    animals: [],
    stations: [{
      station_id: 1,
      name: "401",
      visual: "1/1/2/2",
      terminals: [
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 },
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 }
      ]
    }, {
      station_id: 2,
      name: "402",
      visual: "2/1/3/2",
      terminals: [
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 },
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 }
      ]
    }]
  }
},{
  system_id: 4,
  section_id: 2,
  name: "",
  section_locations: {
    name: "second section",
    location_id: 2,
    animals: [],
    stations: [{
      station_id: 3,
      name: "403",
      visual: "1/1/2/2",
      terminals: [
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 },
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 }
      ]
    }, {
      station_id: 4,
      name: "404",
      visual: "2/1/3/2",
      terminals: [
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 },
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 }
      ]
    }, {
      station_id: 5,
      name: "405",
      visual: "3/1/4/2",
      terminals: [
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 },
        { terminal_id: 501, fk_locations: undefined, fk_devices: undefined, fk_terminal_types: undefined, port: undefined, fk_components: undefined, terminal_config_id: undefined, parent: undefined, next: undefined, sensor_p: undefined, val1_type: 0, val1_min: 0, val1_max: 0, val2_type: 0, val2_min: 0, val2_max: 0, extra: 0, time_act: 0, programmed: 0 }
      ]
    }]
  }
}]